// import axios from 'axios';
import axiosIns from '@/utils/axios';

import type { RouteRecordNormalized } from 'vue-router';
import { UserState } from '@/store/modules/user/types';

export interface LoginData {
  phone: string;
  password: string;
}

export interface LoginRes {
  token: string;
}
export function login(data: LoginData) {
  return axiosIns.post<LoginRes>('/user/login', data);
}

export function logout() {
  return axiosIns.post<LoginRes>('/user/logout');
}

export function getUserInfo() {
  return axiosIns.get<UserState>('/user/info');
}

export function getMenuList() {
  return axiosIns.post<RouteRecordNormalized[]>('/user/menu');
}
